import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useEstablishmentAuth } from '../../context/EstablishmentAuthContext';

function ProtectedRoute({ children }) {
  const { status } = useEstablishmentAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="est-loading-screen">
        <div className="est-spinner" />
        <span>Vérification de ton compte…</span>
      </div>
    );
  }

  if (status !== 'authorized') {
    return <Navigate to="/etablissement/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
